import React, { useState, useRef, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.png";
import "../assets/css/--component-navbar-user.css";
import userImg from "../assets/images/delivery.png";
import notificationDummy from "../assets/images/notification_dummy.png";
import bellIcon from "../assets/images/bell.png";
import { UserContext, UserProvider } from "../context/userContext";
import { onNotification, stopConnection } from "../helper/signalr-service";
import { formatDate, formatSmartTime, formatTime, getCustomerNotification, removeCustomerNotification, updateCustomerNotification } from "../helper/backend-methods";
import ConfirmationModal from "./StatusModal";

function NavBar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // const [user, setUser] = useState({});
  const { user } = useContext(UserContext);
  const dropdownRef = useRef(null);
  const [notificationCount, setNotificationCount] = useState(0);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [customerNotification, setCustomerNotification] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState({ title: "Confirmation", message: "Are you sure you want to clear all notifications?" });
  const notificationRef = useRef(null);
  const history = useNavigate();
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  const toggleNotification = () => {
    setNotificationOpen((prev) => !prev);
  };

  const getCustomerNotifications = () => {
    getCustomerNotification({ status: "All", Limit: 5 }).then(({ data }) => {
      if (data.Status) {
        setNotificationCount(data.Data.UnreadCount || 0);
        setCustomerNotification(data.Data.Notifications);
      }
    });
  }

  const clearCustomerNotification = () => {
    removeCustomerNotification().then(({ data }) => {
      if (data.Status) {
        setNotificationCount(0);
        setCustomerNotification([]);
        setShowModal(false);
      }
    });
  };


  const updateCustomerNotificationAsRead = (id) => {
    updateCustomerNotification("?NotificationId=" + id).then(({ data }) => {
      if (data.Status) {
        getCustomerNotifications();
        history("/account/current-orders");
      }
    });
  };

  const handleCancelSubmit = () => {
    setShowModal(false);
  }
  // Close dropdown when clicked outside
  useEffect(() => {
    getCustomerNotifications();
    const unsubscribe = onNotification((response) => {
      getCustomerNotifications(); // or toast
    });
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }

      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setNotificationOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      unsubscribe();
    };
  }, []);

  return (
    <header className="topbar">
      <div className="topbar-wrapper">
        {/* Left logo */}
        <div className="topbar-left">
        </div>

        {/* Right side */}
        <div className="topbar-right">
          {/* Menu navigation */}
          <Link to="/menu" className="topbar-menu-link" title="View Menu">
            <i className="ri-restaurant-2-line"></i>
            <span>Menu</span>
          </Link>

          {/* Notification icon */}
          {/* <div className="notification-icon">
            <img src={bellIcon} className="nav-icon hover-img" />
            <span className="badge">1</span>
          </div> */}
          <div
            className="notification-icon"
            onClick={toggleNotification}
            ref={notificationRef}
          >
            <img src={bellIcon} className="nav-icon hover-img" />
            <span className="badge">{notificationCount > 0 ? notificationCount : ""}</span>

            {notificationOpen && (
              <div className="notification-dropdown">
                <div className="notification-header" onClick={(e) => { e.stopPropagation(); }}>
                  <h6>Notifications</h6>
                  {notificationCount > 0 && <button className="clear-btn" onClick={() => setShowModal(true)}>Clear Notifications</button>}
                </div>

                <div className="notification-list">
                  {

                    customerNotification?.map((item, idx) => (
                      <div className="notification-item new" key={idx} onClick={(e) => { updateCustomerNotificationAsRead(item.Id); e.stopPropagation(); }}>
                        <img src={userImg} />
                        <div className="d-flex align-items-center justify-content-between gap-2 w-100">
                          <p
                            dangerouslySetInnerHTML={{
                              __html: item.Message
                            }}
                          >
                          </p>
                          <span>{formatSmartTime(formatDate(item.CreatedOnUtc))}</span>
                          {/* <p>Your order <b>#1458</b> is being prepared —
                          it'll be ready for pickup soon!</p>
                         */}
                        </div>

                      </div>
                    ))}
                  {notificationCount <= 0 && (
                    <div className="notification-item"  onClick={(e) => { e.stopPropagation(); }}>
                      <p className="align-items-center">You’re all caught up! No new notifications.</p>
                    </div>
                  )}
                </div>
                {/*<div className="notification-item">
                    <img src={notificationDummy} />
                    <div className="d-flex align-items-center justify-content-between gap-2 w-100">
                      <p><b>Monthly Special</b> - Chef's platter</p>
                      <span>1h ago</span>
                    </div>
                  </div> */}
                <div className="notification-footer" onClick={(e) => { e.stopPropagation(); }}>
                  <Link to="/notifications-history">See All Notifications</Link>
                </div>
              </div>
            )}
          </div>

          {/* User info */}
          <div className="user-info" onClick={toggleDropdown} ref={dropdownRef}>
            <img src={user.ProfilePicture ? user.ProfilePicture : userImg} alt="User" className="user-avatar" />

            <span className="user-name">{user?.FullName}</span>
            <i
              className={`ri-arrow-${dropdownOpen ? "up" : "down"
                }-s-fill dropdown-arrow`}
            ></i>

            {/* Dropdown */}
            {dropdownOpen && (
              <div className="user-dropdown">
                {/* <Link to="/account/profile" className="dropdown-item">
                  <i className="ri-user-line"></i> My Profile
                </Link>
                <Link to="/account/settings" className="dropdown-item">
                  <i className="ri-settings-3-line"></i> Settings
                </Link> */}
                <Link to="/logout" className="user-dropdown-item" onClick={() => stopConnection()}>
                  <i className="ri-logout-circle-r-line"></i> Logout
                </Link>
                {/* <div className="dropdown-divider"></div>
                <button className="dropdown-item logout-btn">
                  <i className="ri-logout-circle-r-line"></i> Logout
                </button> */}
              </div>
            )}
          </div>
        </div>
      </div>
      <ConfirmationModal
        isOpen={showModal}
        toggle={() => setShowModal(false)}
        type="confirmation"
        title={confirmationMessage.title}
        message={confirmationMessage.message}
        ButtonText="No"
        ButtonTextYes="Yes"
        onCancel={handleCancelSubmit}
        onYes={clearCustomerNotification}
        isShowYesButton={true}
      />
    </header>


  );
}

export default NavBar;
